import React from 'react';
import PropTypes from 'prop-types';
import { ResponsivePie } from '@nivo/pie';

const config = {
  margin: { top: 50, bottom: 35 },
  innerRadius: 0.7,
  colors: ['#5ed490', '#157efb'],
  enableRadialLabels: true,
  radialLabelsSkipAngle: 10,
  radialLabelsTextXOffset: 6,
  radialLabelsTextColor: '#333333',
  radialLabelsLinkOffset: 0,
  radialLabelsLinkDiagonalLength: 16,
  radialLabelsLinkHorizontalLength: 24,
  radialLabelsLinkStrokeWidth: 1,
  radialLabelsLinkColor: { from: 'color' },
  sliceLabel: 'value',
  slicesLabelsSkipAngle: 10,
  slicesLabelsTextColor: 'white',
  animate: true,
  sortByValue: true,
  motionStiffness: 90,
  motionDamping: 15,
};

function PieChart(props) {
  return (
    <div>
      <div style={{ height: 250 }}>
        <ResponsivePie {...config} {...props} />
      </div>
      <div className="chart-data-row">
        {props.data.map(({ id, value }) => (
          <div key={id}>
            <div className="chart-data-label">{id}</div>
            <div className="chart-data-value">{value}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

PieChart.propTypes = {
  data: PropTypes.array.isRequired,
};

export default PieChart;
